<template>
  <UButton
    color="white"
    class="flex-1 justify-center"
    size="lg"
    @click="handleSocialLogin"
  >
    <AImg
      height="24"
      width="24"
      :src="`/images/auth-providers/${provider}.svg`"
    />
    {{ label || capitalize(provider) }}
  </UButton>
</template>

<script setup lang="ts">
import type { ASocialProviderButtonProps } from '#common/types'

const props = withDefaults(defineProps<ASocialProviderButtonProps>(), {
  redirectQueryParams: () => ({}),
})

async function handleSocialLogin() {
  await navigateTo(
    {
      path: `/auth/providers/redirect`,
      query: {
        origin: useRequestURL().origin,
        provider: props.provider,
        redirectQueryParams: JSON.stringify(props.redirectQueryParams),
      },
    },
    {
      external: true,
    },
  )
}
</script>
